import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>All Right Reserved @pererapers</p>
      </div>
    </footer>
  );
}